import { Typography } from 'antd';
import { type TaskTemplateListType, type TaskTemplateType } from 'crm-atoms/queries';

function getTaskTemplateOptionsByType(
  taskTemplates: TaskTemplateListType['taskTemplates'],
  type: TaskTemplateType['taskType'],
) {
  return taskTemplates.filter((template) => template.taskType === type).map((template) => ({
    label: template.name,
    value: Number(template.id),
  }));
}

export const getTaskTemplateOptions = (taskTemplateData: TaskTemplateListType) => [{
  label: (
    <Typography.Text type="secondary">
      Appointment
    </Typography.Text>
  ),
  title: 'Appointment',
  options: getTaskTemplateOptionsByType(taskTemplateData?.taskTemplates ?? [], 'appointment'),
},
{
  label: (
    <Typography.Text type="secondary">
      Todo
    </Typography.Text>
  ),
  title: 'Todo',
  options: getTaskTemplateOptionsByType(taskTemplateData?.taskTemplates ?? [], 'todo'),
}].filter((option) => option.options.length > 0);
